module.exports = __webpack_public_path__ + "img/ecfc199f45a7aef9f2482b50f89ea868.png";